import Vue from "vue";

const invite = {
    namespaced: true,

    state: {
        showInviteModal: false,
        activeInviteHousemate: null,
        householdUsers: [],
        currentBillPayer: null,
    },

    getters: {
        /*
        Retrieve all users in the household
         */
        getUsers: (state) => {
            return state.householdUsers;
        },

        /*
        Retrieve the user at a specific index
         */
        getUser: (state) => (index) => {
            if (typeof state.householdUsers[index] !== 'undefined') {
                return state.householdUsers[index];
            } else {
                return null;
            }
        },

        /*
        Retrieve the main bill payer
         */
        getBillPayer: (state) => {
            return state.currentBillPayer;
        },

        /*
        Retrieve the currently active user
         */
        getActiveUser: (state, getters) => {
            return getters.getUser(state.activeInviteHousemate);
        },

        /*
        Retrieve whether the invite multi modal is open
         */
        getShowInviteModal: (state) => {
            return state.showInviteModal;
        },

        /*
        Retrieve boolean depending on whether the
         */
        getAllUsersCompleted: (state) => {
            for (let i = 1; i < _.size(state.householdUsers); i++) {
                if (_.isEmpty(state.householdUsers[i])) {
                    return false;
                }
            }
            return true;
        },
    },

    mutations: {
        /*
        Set the household users from database
         */
        setUsers: (state, { users, amount }) => {
            for (let i = 0; i < amount; i++) {
                if (typeof users[i] !== 'undefined') {
                    state.householdUsers.push(users[i]);
                } else {
                    state.householdUsers.push({});
                }
            }
        },

        addUser : (state, payload) => {
            for(let k in payload) {
                Vue.set(state.householdUsers[state.activeInviteHousemate], k, payload[k]);
            }
        },

        updateCurrentBillPayer: (state, payload) => {
            state.currentBillPayer = payload;
        },

        /*
        Show the invite multi modal and fill content
         */
        showInviteModal: (state, payload) => {
            state.activeInviteHousemate = payload;
            state.showInviteModal = true;
        },

        /*
        Hide the invite modal and reset content
         */
        hideInviteModal: (state) => {
            state.showInviteModal = false;
            state.activeInviteHousemate = null;
        },
    },

    actions: {

    },

};

export default invite;
